/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierMeeting,
  CarrierMeetingPreview,
  CarrierMeetingSummary,
  LogCarrierMeetingRequest,
  LogMeetingResult,
  PreviewCarrierMeetingRequest,
  RecentJamieMeeting,
} from "../models/index";
import {
  CarrierMeetingFromJSON,
  CarrierMeetingToJSON,
  CarrierMeetingPreviewFromJSON,
  CarrierMeetingPreviewToJSON,
  CarrierMeetingSummaryFromJSON,
  CarrierMeetingSummaryToJSON,
  LogCarrierMeetingRequestFromJSON,
  LogCarrierMeetingRequestToJSON,
  LogMeetingResultFromJSON,
  LogMeetingResultToJSON,
  PreviewCarrierMeetingRequestFromJSON,
  PreviewCarrierMeetingRequestToJSON,
  RecentJamieMeetingFromJSON,
  RecentJamieMeetingToJSON,
} from "../models/index";

export interface GetMeetingRequest {
  carrierMeetingId: string;
}

export interface ListMeetingsForCarrierRequest {
  carrierIdentifier: string;
}

export interface LogMeetingRequest {
  logCarrierMeetingRequest: LogCarrierMeetingRequest;
}

export interface PreviewMeetingRequest {
  previewCarrierMeetingRequest: PreviewCarrierMeetingRequest;
}

/**
 *
 */
export class CarrierMeetingsApi extends runtime.BaseAPI {
  /**
   */
  async getMeetingRaw(
    requestParameters: GetMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierMeeting>> {
    if (requestParameters["carrierMeetingId"] == null) {
      throw new runtime.RequiredError(
        "carrierMeetingId",
        'Required parameter "carrierMeetingId" was null or undefined when calling getMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-meetings/{carrierMeetingId}`.replace(
          `{${"carrierMeetingId"}}`,
          encodeURIComponent(String(requestParameters["carrierMeetingId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierMeetingFromJSON(jsonValue),
    );
  }

  /**
   */
  async getMeeting(
    requestParameters: GetMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierMeeting> {
    const response = await this.getMeetingRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async listMeetingsForCarrierRaw(
    requestParameters: ListMeetingsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierMeetingSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling listMeetingsForCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-meetings/for-carrier`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierMeetingSummaryFromJSON),
    );
  }

  /**
   */
  async listMeetingsForCarrier(
    requestParameters: ListMeetingsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierMeetingSummary>> {
    const response = await this.listMeetingsForCarrierRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Persist the meeting snapshot and create todos for the confirmed action items.
   * Persist the meeting snapshot and create todos for the confirmed action items.
   */
  async logMeetingRaw(
    requestParameters: LogMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LogMeetingResult>> {
    if (requestParameters["logCarrierMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "logCarrierMeetingRequest",
        'Required parameter "logCarrierMeetingRequest" was null or undefined when calling logMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-meetings/log`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogCarrierMeetingRequestToJSON(
          requestParameters["logCarrierMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LogMeetingResultFromJSON(jsonValue),
    );
  }

  /**
   * Persist the meeting snapshot and create todos for the confirmed action items.
   * Persist the meeting snapshot and create todos for the confirmed action items.
   */
  async logMeeting(
    requestParameters: LogMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LogMeetingResult> {
    const response = await this.logMeetingRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewMeetingRaw(
    requestParameters: PreviewMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierMeetingPreview>> {
    if (requestParameters["previewCarrierMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "previewCarrierMeetingRequest",
        'Required parameter "previewCarrierMeetingRequest" was null or undefined when calling previewMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-meetings/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewCarrierMeetingRequestToJSON(
          requestParameters["previewCarrierMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierMeetingPreviewFromJSON(jsonValue),
    );
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewMeeting(
    requestParameters: PreviewMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierMeetingPreview> {
    const response = await this.previewMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user --- you never see anyone else\'s meetings.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentMeetingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<RecentJamieMeeting>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-meetings/recent-meetings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RecentJamieMeetingFromJSON),
    );
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user --- you never see anyone else\'s meetings.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentMeetings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<RecentJamieMeeting>> {
    const response = await this.recentMeetingsRaw(initOverrides);
    return await response.value();
  }
}
